import { ChangeEvent, useMemo } from 'react';

import { Callable, Optional } from '@vimeo/core/types/generic';
import { CallablePlaceholder } from '@vimeo/live-core/types/general';

import { sharedTranslations as translations } from '../../../../translations/shared';

export interface IUseModalParams {
  deleteMessageId: Optional<string>;
  handleDeleteCancel: Callable;
  handleDeleteConfirm: Callable;
  blockUserId: Optional<string>;
  handleBlockUserCancel: Callable;
  handleBlockUserConfirm: Callable;
  onCheckAskAgain: (event: ChangeEvent<HTMLInputElement>) => void;
}

export interface IModalProps {
  active: boolean;
  header: string;
  text: string;
  cancelAction: Callable;
  confirmAction: Callable;
  showAskAgainCheckBox?: boolean;
  onCheck?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function useModalProps({
  deleteMessageId,
  handleDeleteCancel,
  handleDeleteConfirm,
  blockUserId,
  handleBlockUserCancel,
  handleBlockUserConfirm,
  onCheckAskAgain,
}: IUseModalParams): IModalProps {
  return useMemo(() => {
    if (Boolean(deleteMessageId))
      return {
        active: Boolean(deleteMessageId),
        header: translations.deleteMessage,
        text: translations.areYouSureDeleteMessage,
        cancelAction: handleDeleteCancel,
        confirmAction: handleDeleteConfirm,
        onCheck: onCheckAskAgain,
        showAskAgainCheckBox: true,
      };

    if (Boolean(blockUserId))
      return {
        active: Boolean(blockUserId),
        header: translations.blockUser,
        text: translations.areYouSureBlockUser,
        cancelAction: handleBlockUserCancel,
        confirmAction: handleBlockUserConfirm,
      };

    return {
      active: false,
      header: '',
      text: '',
      cancelAction: CallablePlaceholder,
      confirmAction: CallablePlaceholder,
    };
  }, [
    deleteMessageId,
    handleDeleteCancel,
    handleDeleteConfirm,
    blockUserId,
    handleBlockUserCancel,
    handleBlockUserConfirm,
    onCheckAskAgain,
  ]);
}
